// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.nonum_box .label_mod .el-checkbox-button--mini .el-checkbox-button__inner{\n  margin:0.05rem;\n  border-radius: 4px;\n}\n.nonum_box .two_mod .el-tag--small{\n  margin:0.05rem;\n}\n.nonum_box .submitBox{\n  top: 5.5rem;\n  right: 3.7rem;\n}\n", ""]);
// Exports
module.exports = exports;
